<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div>
    <div class="row">
      <div class="twelve columns">
        <sls-table-head
          v-if="btn_info.show_table_head !== false"
          :Batch="batch"
          :Search="search"
          :BtnInfo="btn_info"
          :StylePlain="StylePlain"
          @on-search="onSearch"
          @on-btn-event="onBtnEvent"
        >
          <template #sls-header-after>
            <slot name="header-after" />
          </template>
          <template #sls-header-before>
            <slot name="header-before" />
          </template>
        </sls-table-head>
        <div class="list">
          <el-table
            ref="elTable"
            border
            style="width: 100%"
            align="center"
            :data="list"
            :row-class-name="tableRowClassName"
            :summary-method="summaryMethod"
            :show-summary="btn_info.summary === true"
            :show-header="btn_info.show_header !== false"
            :fit="btn_info.fit !== false"
            :row-key="btn_info.row_key"
            :default-expand-all="btn_info.expand_all === true"
            @selection-change="onSelectionChange"
          >
            <el-table-column
              v-if="expand && expand.show && expand.show===true && (!expand.position || expand.position==='left')"
              type="expand"
              :fixed="expand.fixed"
            >
              <template #default="scope">
                <slot
                  name="expand"
                  :data="scope.row"
                  :index="scope.$index"
                />
              </template>
            </el-table-column>

            <el-table-column
              v-if="btn_info.batch!==false"
              type="selection"
              width="55"
            />

            <template v-for="(field, index) in fields">
              <el-table-column
                v-if="!field.type && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'left'"
                :sortable="field.sort || false"
                :formatter="field.formatter"
                :filters="field.filter_list"
                :filter-method="field.filter_method"
                :filter-multiple="field.filter_multiple"
                :filtered-value="field.filtered_value"
                :style="field.style"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
                :render-header="field.render_header"
                :show-overflow-tooltip="field.show_overflow_tooltip || false"
              >
                <template #header>
                  <el-input
                    v-if="field.render_input"
                    v-model="internalValues[index]"
                    :placeholder="field.label"
                    :type="field.type_input || 'text'"
                    @change="field.updateValue"
                  />
                  <el-date-picker
                    v-if="field.render_date"
                    v-model="internalValues[index]"
                    :type="field.type_date || 'date'"
                    :format="field.format || 'DD/MM/YYYY'"
                    :range-separator="field.range_separator || ' - '"
                    :end-placeholder="field.end_placeholder || 'Fim'"
                    :start-placeholder="field.start_placeholder || 'Início'"
                    :placeholder="field.label || 'Selecione'"
                    @change="field.updateValue"
                  />
                  <el-select
                    v-if="field.render_select"
                    v-model="internalValues[index]"
                    :placeholder="field.label || 'Selecione'"
                    :name="field.label"
                    clearable
                    filterable
                    @change="field.updateValue"
                  >
                    <el-option
                      v-for="item in field.render_list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='sort' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'left'"
                :formatter="field.formatter"
                :filters="field.filter_list"
                :filter-method="field.filter_method"
                :filter-multiple="field.filter_multiple"
                :filtered-value="field.filtered_value"
                :style="field.style"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
                :render-header="field.render_header"
                :show-overflow-tooltip="field.show_overflow_tooltip || false"
              >
                <template #header>
                  <el-input
                    v-if="field.render_input"
                    v-model="field.value"
                    :placeholder="field.label"
                    :type="field.type_input || 'text'"
                  />
                  <el-date-picker
                    v-if="field.render_date"
                    v-model="field.value"
                    :type="field.type_date || 'date'"
                    :format="field.format || 'DD/MM/YYYY'"
                    :range-separator="field.range_separator || ' - '"
                    :end-placeholder="field.end_placeholder || 'Fim'"
                    :start-placeholder="field.start_placeholder || 'Início'"
                    :placeholder="field.label || 'Selecione'"
                  />
                  <el-select
                    v-if="field.render_select"
                    v-model="field.value"
                    :placeholder="field.label || 'Selecione'"
                    :name="field.label"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in field.render_list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  {{ field.label + ' ' }}
                  <el-button
                    type=""
                    size="small"
                    :plain="StylePlain"
                    @click="sort(field)"
                  >
                    <font-awesome-icon icon="sort" />
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='search' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'left'"
                :style="field.style"
                :width="field.width"
                :min-width="field.min_width"
                :formatter="field.formatter"
                :value="field.value"
                :fixed="field.fixed"
              >
                <template #header="scope">
                  <el-input
                    v-model="field.value"
                    :size="scope.column.size"
                    :placeholder="scope.column.label"
                    :type="scope.column.type_input"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='double_value' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key1"
                :prop="field.key1"
                :label="field.label"
                :align="field.align || 'left'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #header>
                  <el-input
                    v-if="field.render_input"
                    v-model="field.value"
                    :placeholder="field.label"
                    :type="field.type_input || 'text'"
                  />
                  <el-date-picker
                    v-if="field.render_date"
                    v-model="field.value"
                    :type="field.type_date || 'date'"
                    :format="field.format || 'DD/MM/YYYY'"
                    :range-separator="field.range_separator || ' - '"
                    :end-placeholder="field.end_placeholder || 'Fim'"
                    :start-placeholder="field.start_placeholder || 'Início'"
                    :placeholder="field.label || 'Selecione'"
                  />
                  <el-select
                    v-if="field.render_select"
                    v-model="field.value"
                    :placeholder="field.label || 'Selecione'"
                    :name="field.label"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in field.render_list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
                <template #default="scope">
                  <span v-if="!verificarObjeto(field.key1) && !verificarObjeto(field.key2)">
                    {{ scope.row[field.key1] }}{{ field.separator }}{{ scope.row[field.key2] }}
                  </span>
                  <span v-else>
                    {{ obterDadosLinha(scope.row, field.key1) }}
                    {{ field.separator }}
                    {{ obterDadosLinha(scope.row, field.key2) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='tooltip' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #header>
                  <el-input
                    v-if="field.render_input"
                    v-model="field.value"
                    :placeholder="field.label"
                    :type="field.type_input || 'text'"
                  />
                  <el-date-picker
                    v-if="field.render_date"
                    v-model="field.value"
                    :type="field.type_date || 'date'"
                    :format="field.format || 'DD/MM/YYYY'"
                    :range-separator="field.range_separator || ' - '"
                    :end-placeholder="field.end_placeholder || 'Fim'"
                    :start-placeholder="field.start_placeholder || 'Início'"
                    :placeholder="field.label || 'Selecione'"
                  />
                  <el-select
                    v-if="field.render_select"
                    v-model="field.value"
                    :placeholder="field.label || 'Selecione'"
                    :name="field.label"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in field.render_list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
                <template #default="scope">
                  <el-tooltip
                    v-if="!verificarObjeto(field.tooltip)"
                    effect="dark"
                    :content="scope.row[field.tooltip]"
                  >
                    <span v-if="!verificarObjeto(field.key)">{{ scope.row[field.key] }}</span>
                    <span v-else>{{ obterDadosLinha(scope.row, field.key) }}</span>
                  </el-tooltip>
                  <el-tooltip
                    v-else
                    effect="dark"
                    :content="obterDadosLinha(scope.row, field.tooltip)"
                  >
                    <span v-if="!verificarObjeto(field.key)">{{ scope.row[field.key] }}</span>
                    <span v-else>{{ obterDadosLinha(scope.row, field.key) }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='image' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <el-image
                    :src="(field.host || '')+scope.row[field.key]"
                    alt=""
                    fit="contain"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='icon' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'left'"
                :width="field.width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <font-awesome-icon
                    v-if="field.icon"
                    :title="field.title"
                    :icon="field.icon(scope.row)"
                  />
                  <span v-if="field.show_text === undefined || field.show_text">
                    {{ scope.row[field.key] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='link' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <a
                    :target="field.link_target || '_self'"
                    :href="scope.row[field.key]"
                  >{{ field.link_text || scope.row[field.key] }}</a>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='boolean' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <font-awesome-icon
                    v-if="scope.row[field.key]"
                    icon="check"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='tag' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <el-tag
                    v-for="tag in scope.row[field.key]"
                    :key="tag"
                    :type="field.typetag"
                  >
                    {{ tag }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='radio' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <el-radio
                    v-model="selectedRadio"
                    :label="scope.row[field.key]"
                    @change="onRadioChange(field.key, scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='input' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <div class="el-input el-input__wrapper" v-if="field.money">
                    <money
                      :model-value="valorInicial(scope.row[field.key])"
                      @update:model-value="(val) => scope.row[field.key] = val"
                      class="el-input__inner"
                      v-bind="field.params"
                      :readonly="field.readonly && field.readonly({ data:scope.row, dataIndex:scope.$index, list:list })"
                      @change="onInputColumnChange(field.key, scope.row)"
                    />
                  </div>
                  <div v-if="field.mask" class="el-input el-input__wrapper">
                    <the-mask
                      v-model="scope.row[field.key]"
                      class="el-input__inner"
                      :mask="field.mask"
                      auto-complete="off"
                      :readonly="field.readonly && field.readonly({ data:scope.row, dataIndex:scope.$index, list:list })"
                      @change="onInputColumnChange(field.key, scope.row)"
                    />
                  </div>
                  <el-input
                    v-if="!field.money && !field.mask"
                    v-model="scope.row[field.key]"
                    :readonly="field.readonly && field.readonly({ data:scope.row, dataIndex:scope.$index, list:list })"
                    @change="onInputColumnChange(field.key, scope.row)"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='date' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
                :type="field.type_selection"
              >
                <template #default="scope">
                  <el-date-picker
                    v-model="scope.row[field.key]"
                    :type="field.type_date || 'date'"
                    :format="field.format || 'DD/MM/YYYY'"
                    :range-separator="field.range_separator || ' - '"
                    :end-placeholder="field.end_placeholder || 'Fim'"
                    :start-placeholder="field.start_placeholder || 'Início'"
                    :readonly="field.readonly && field.readonly({ data:scope.row, dataIndex:scope.$index, list:list })"
                    :placeholder="field.placeholder || 'Selecione'"
                  />
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='checkbox' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
                :type="field.type_column"
              >
                <template #default="scope">
                  <el-checkbox
                    v-model="scope.row[field.key]"
                    :name="scope.$index.toString()"
                    :disabled="field.checkBoxDisabled ? field.checkBoxDisabled(scope.row) : false"
                    @change="onCheckBoxChange($event, scope.$index, field.key, scope.row)"
                  >
                    {{ field.checkBoxLabel ? field.checkBoxLabel(scope.row) : '' }}
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='html' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :prop="field.key"
                :label="field.label"
                :align="field.align || 'left'"
                :sortable="field.sort || false"
                :formatter="field.formatter"
                :filters="field.filter_list"
                :filter-method="field.filter_method"
                :filter-multiple="field.filter_multiple"
                :filtered-value="field.filtered_value"
                :style="field.style"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
                :show-overflow-tooltip="field.show_overflow_tooltip || false"
              >
                <template #header>
                  <el-input
                    v-if="field.render_input"
                    v-model="field.value"
                    :placeholder="field.label"
                    :type="field.type_input || 'text'"
                  />
                  <el-date-picker
                    v-if="field.render_date"
                    v-model="field.value"
                    :type="field.type_date || 'date'"
                    :format="field.format || 'DD/MM/YYYY'"
                    :range-separator="field.range_separator || ' - '"
                    :end-placeholder="field.end_placeholder || 'Fim'"
                    :start-placeholder="field.start_placeholder || 'Início'"
                    :placeholder="field.label || 'Selecione'"
                  />
                  <el-select
                    v-if="field.render_select"
                    v-model="field.value"
                    :placeholder="field.label || 'Selecione'"
                    :name="field.label"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in field.render_list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
                <template #default="scope">
                  {{ strip(scope.row[field.key]) }}
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='selectEnum' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #header>
                  <el-select
                    v-if="field.render_select"
                    v-model="field.value"
                    :placeholder="field.label || 'Selecione'"
                    :name="field.label"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in field.render_list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
                <template #default="scope">
                  <el-select
                    v-model="scope.row[field.key]"
                    placeholder="Selecione"
                  >
                    <el-option
                      v-for="item in field.list"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                      :disabled="field.readonly && field.readonly({ data:scope.row, dataIndex:scope.$index, list:list })"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='button' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
                :show-overflow-tooltip="field.show_overflow_tooltip || false"
              >
                <template #default="scope">
                  <div v-if="field.hasMessage && field.hasMessage({ data:scope.row, dataIndex:scope.$index, list:list })">
                    <el-alert
                      :title="field.message"
                      :type="field.type_message || 'warning'"
                      :closable="false"
                    />
                  </div>
                  <el-button
                    v-else-if="scope.row[field.key] || field.text_button"
                    :size="field.size_button || 'small'"
                    :type="field.type_button || 'primary'"
                    :link="field.link || false"
                    :plain="StylePlain"
                    :disabled="field.disabled"
                    @click="onBtnEvent({type:'Column', column:field.label, data:scope.row})"
                  >
                    <font-awesome-icon
                      v-if="field.icon"
                      :title="field.title"
                      :icon="field.icon(scope.row)"
                    />
                    {{ scope.row[field.key] ? field.formatter ? field.formatter(scope.row[field.key]) : scope.row[field.key] : field.text_button }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                v-if="field.type && field.type==='dropdown' && (!field.isVisible || field.isVisible === 'yes')"
                :key="field.key"
                :label="field.label"
                :align="field.align || 'center'"
                :formatter="field.formatter"
                :width="field.width"
                :min-width="field.min_width"
                :fixed="field.fixed"
              >
                <template #default="scope">
                  <el-dropdown
                    v-show="!field.isButtonVisible || scope.row[field.isButtonVisible] === 'yes'"
                    trigger="click"
                  >
                    <el-button
                      size="small"
                      type="primary"
                      :plain="StylePlain"
                    >
                      {{ field.text_dropdown }}
                      <el-icon class="is-more">
                        <More />
                      </el-icon>
                    </el-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item
                          v-for="option in field.options"
                          :key="option"
                          @click="onBtnEvent({type:'DropdownColumn', column:field.label, data:scope.row, option: option})"
                        >
                          {{ option }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </template>
              </el-table-column>
            </template>
            <el-table-column
              v-if="btn_info.all!==false"
              :align="'center'"
              :label="btn_info.label || 'Opções'"
              :width="btn_info.width || 160"
              :fixed="btn_info.fixed_options"
            >
              <template #default="scope">
                <!-- <el-button
                            v-if='btn_info.list && btn_info.list_position==="before" && (!btn_info.view || !btn_info.view.list || btn_info.view.list({ data:scope.row, dataIndex:scope.$index, list:list }))'
                            v-for='(btn,index) in btn_info.list'
                            :key='btn.text'
                            :icon='btn.icon || "view"'
                            :type="btn.type || 'info'"
                            :size="btn.size || 'small'"
                            @click='onCustomBtnEvent({list:list,data:scope.row,dataIndex:scope.$index,btnIndex:index,btnInfo:btn})'>
                    </el-button> -->
                <span v-if="btn_info.list && btn_info.list_position==='before'">
                  <el-button
                    v-for="(btn,index) in btn_info.list.filter((b) => (!btn_info.view || !btn_info.view.list
                      || btn_info.view.list({ data:scope.row, dataIndex:scope.$index, list:list, btnText: b.text })) && b.isVisible !== false)"
                    :key="btn.text"
                    :link="btn.link"
                    :type="btn.type || 'primary'"
                    :icon="btn.icon || ''"
                    :size="btn.size || 'small'"
                    :plain="StylePlain"
                    @click="onCustomBtnEvent({list:list,data:scope.row,dataIndex:scope.$index,btnIndex:index,btn:btn})"
                  >
                    {{ btn.text }}
                  </el-button>
                </span>
                <el-dropdown
                  v-if="btn_info.dropdown==true && btn_info.dropdown_before==true && (!btn_info.view || !btn_info.view.dropdown || btn_info.view.dropdown({ data:scope.row, dataIndex:scope.$index, list:list }))"
                  trigger="click"
                >
                  <el-button
                    size="large"
                    type="primary"
                    :plain="StylePlain"
                  >
                    {{ btn_info.dropdown_text }}
                    <el-icon><More /></el-icon>
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        v-for="option in DropdownList.filter((op) => (!btn_info.view || !btn_info.view.dropdownOptions ||btn_info.view.dropdownOptions({ data:scope.row, dataIndex:scope.$index, list:list, option:op })))"
                        :key="option"
                        @click="onBtnEvent({type:'Dropdown',data:scope.row,dataIndex:scope.$index,list:list, option})"
                      >
                        {{ option }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

                <span v-if="btn_info.default!==false">
                  <el-button
                    v-if="btn_info.button_custom === true && (!btn_info.view || !btn_info.view.button_custom || btn_info.view.button_custom({ data:scope.row, dataIndex:scope.$index, list:list }))"
                    :type="btn_info.button_custom_type || 'primary'"
                    :title="btn_info.button_custom_title || ''"
                    :size="btn_info.button_custom_size || 'small'"
                    :plain="StylePlain || btn_info.button_custom_plain === true"
                    :circle="StyleCircle && btn_info.button_custom_text === undefined"
                    @click="onBtnEvent({type:'Custom',data:scope.row,dataIndex:scope.$index,list:list})"
                  >
                    <font-awesome-icon
                      v-if="btn_info.button_custom_icon"
                      :icon="btn_info.button_custom_icon"
                    />{{ btn_info.button_custom_text || '' }}</el-button>
                  <el-button
                    v-if="btn_info.select!==false && (!btn_info.view || !btn_info.view.select || btn_info.view.select({ data:scope.row, dataIndex:scope.$index, list:list }))"
                    :type="btn_info.select_type || 'info'"
                    :icon="btn_info.select_icon || ''"
                    :size="btn_info.select_size || 'small'"
                    :plain="StylePlain"
                    :circle="StyleCircle"
                    @click="onBtnEvent({type:'Select',data:scope.row,dataIndex:scope.$index,list:list})"
                  >
                    <font-awesome-icon :icon="btn_info.select_icon || 'eye'" />{{ btn_info.select_text || '' }}</el-button>
                  <!-- el-icon-view -->
                  <el-button
                    v-if="btn_info.update!==false && (!btn_info.view || !btn_info.view.update || btn_info.view.update({ data:scope.row, dataIndex:scope.$index, list:list }))"
                    type="primary"
                    :icon=" StyleCircle ? '' : 'edit'"
                    title="Editar"
                    size="small"
                    :circle="StyleCircle"
                    :plain="StylePlain"
                    @click="onBtnEvent({type:'Update',data:scope.row,dataIndex:scope.$index,list:list})"
                  ><font-awesome-icon
                    v-if="StyleCircle"
                    icon="pencil-alt"
                  />{{ btn_info.update_text || '' }}</el-button>
                  <el-button
                    v-if="btn_info.delete!==false && (!btn_info.view || !btn_info.view.delete || btn_info.view.delete({ data:scope.row, dataIndex:scope.$index, list:list }))"
                    type="danger"
                    :icon=" StyleCircle ? '' : 'delete'"
                    size="small"
                    title="Excluir"
                    :plain="StylePlain"
                    :circle="StyleCircle"
                    @click="onBtnEvent({type:'Delete',data:scope.row,dataIndex:scope.$index,list:list})"
                  ><font-awesome-icon
                    v-if="StyleCircle"
                    icon="trash"
                  />{{ btn_info.delete_text || '' }}</el-button>
                  <el-button
                    v-if="btn_info.audit==true && (!btn_info.view || !btn_info.view.audit || btn_info.view.audit({ data:scope.row, dataIndex:scope.$index, list:list }))"
                    type="warning"
                    title="Auditar"
                    size="small"
                    :plain="StylePlain"
                    :circle="StyleCircle"
                    @click="onBtnEvent({type:'Audit',data:scope.row,dataIndex:scope.$index,list:list})"
                  ><font-awesome-icon icon="user-secret" />{{ btn_info.audit_text || '' }}</el-button>
                </span>
                <el-dropdown
                  v-if="btn_info.dropdown==true && btn_info.dropdown_before !==true && (!btn_info.view || !btn_info.view.dropdown || btn_info.view.dropdown({ data:scope.row, dataIndex:scope.$index, list:list }))"
                  trigger="click"
                >
                  <el-button
                    size="small"
                    type="primary"
                    title="Opções"
                    :icon=" StyleCircle ? '' : 'more'"
                    :plain="StylePlain"
                    :circle="StyleCircle && btn_info.dropdown_text === undefined"
                  >
                    <font-awesome-icon
                      v-if="StyleCircle && btn_info.dropdown_text === undefined"
                      icon="chevron-down"
                    />{{ btn_info.dropdown_text }}
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        v-for="option in DropdownList.filter((op) => (!btn_info.view || !btn_info.view.dropdownOptions ||btn_info.view.dropdownOptions({ data:scope.row, dataIndex:scope.$index, list:list, option:op })))"
                        :key="option"
                        @click="onBtnEvent({type:'Dropdown',data:scope.row,dataIndex:scope.$index,list:list, option})"
                      >
                        {{ option }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>

                <!--
                      my-key-listlmy-key-listlist,data:scope.row,dataIndex:scope.$index,btnIndex:index,btnInfo:btn}
                    -->
                <span v-if="btn_info.list && (btn_info.list_position==='after' || !btn_info.list_position)">
                  <el-button
                    v-for="(btn,index) in btn_info.list.filter((b) => b.isVisible !== false && (!btn_info.view || !btn_info.view.list || btn_info.view.list({ data:scope.row, dataIndex:scope.$index, list:list, btnText: b.text })))"
                    :key="btn.text"
                    :link="btn.link"
                    :type="btn.type || 'primary'"
                    :size="btn.size || 'small'"
                    :plain="StylePlain"
                    @click="onCustomBtnEvent({list:list,data:scope.row,dataIndex:scope.$index,btnIndex:index,btn:btn})"
                  >
                    {{ btn.text }}
                  </el-button>
                </span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="expand && expand.show && expand.show===true && expand.position && expand.position==='right'"
              type="expand"
            >
              <template #default="scope">
                <slot
                  name="expand"
                  :data="scope.row"
                  :index="scope.$index"
                />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="row">
      <div
        class="twelve columns"
        style="text-align: center;"
      >
        <el-pagination
          v-if="pagination && ( (pagination.total!==undefined && pagination.total>0) || (pagination['page_count']!==undefined && pagination['page_count']>0) )"
          class="pagination"

          :page-sizes="pagination.page_sizes"
          :page-size="pagination.page_size"
          :layout="pagination.layout"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="onChangeCurrentPage"
          @size-change="onChangePageSize"
        />
      </div>
    </div>
    <div class="twelve columns">
      <br>
    </div>
  </div>
</template>

<script>
import { More } from '@element-plus/icons-vue';
import { mapState } from 'pinia';
import { mainStore } from '@/store/index';
import SlsTableHead from './SlsTableHead.vue';

export default {
  name: 'ListData',
  components: { SlsTableHead, More },
  emits: [
    'update:value',
    'onSelectionChange',
    'onSelectionChangeObj',
    'onSearch',
    'onClickBtnAdd',
    'onClickBtnUpdate',
    'onClickBtnDelete',
    'onClickBtnDropdown',
    'onClickBtnBatchDelete',
    'onClickBtnCustom',
    'onClickBtnSelect',
    'onClickBtnBatchAdd',
    'onClickBtnBatchUpdate',
    'onClickBtnAudit',
    'onClickBtnCustomDelete',
    'onClickBtnCustomSearch',
    'onClickBtnCustomButton',
    'onChangeCurrentPage',
    'onChangePageSize',
    'onRadioChange',
    'onInputColumnChange',
    'onCheckBoxChange',
    'onClickBtnColumn',
    'onClickBtnDropdownColumn',
    'onClickBtn',
  ],
  data() {
    return {
      batch_flag: true, // suportar multipla selecao exclusao
      batch_datas: [],
      batch_ids: [],
      selection: false,
      batch: {
        flag: true,
        datas: [],
        ids: [],
      },

      list: this.List, // lista principal
      fields: this.FieldList, // lista de campos
      expand: this.Expand, // suporte expandir
      btn_info: this.BtnInfo, // informacao botao
      internalValues: [],
      pagination: this.Pagination, // controle paginacao
      search: this.Search, // controle pesquisa
      tableRowClassName: this.TableRowClassName, // aparencia personalizada das linhas
      summaryMethod: this.SummaryMethod, // metodo para personalizar sumario
      selectedRadio: null, // variavel para guardar opcao radio selecionada
    };
  },

  computed: {
    ...mapState(mainStore, ['fetching']),
  },

  /**
  * 监控参数
  * @type {Object}
  */
  watch: {
    List(v) {
      if (v) {
        this.list = v;
      }
    },

    FieldList(v) {
      if (v) {
        this.fields = v;
        this.internalValues = this.fields.map((field) => field.value);
      }
    },

    Selection(v) {
      this.selection = v;
    },

    Expand(v) {
      this.expand = v;
    },

    BtnInfo(v) {
      this.btn_info = v;
    },

    Pagination(v) {
      this.pagination = v;
    },

    Search(v) {
      this.search = v;
    },

    TableRowClassName(v) {
      this.tableRowClassName = v;
    },

    SummaryMethod(v) {
      this.summaryMethod = v;
    },

    'field.value': function (newVal) {
      this.internalValue = newVal;
    },
  },

  methods: {

    valorInicial(valor) {
      return valor || 0;
    },

    /**
    * Cria uma lista com o id dos itens selecionados
    * @param  {array} val array dos itens selecionados
    */
    onSelectionChange(val) {
      this.batch.datas = val;

      this.batch.ids = [];

      if (val.length) {
        this.batch.flag = false;
        for (let i = 0; i < val.length; i += 1) {
          this.batch.ids.push(val[i].id);
        }
      } else {
        this.batch.flag = true;
      }

      /**
      * Eventos Mudança CheckBox, o primeiro parâmetro é os ids selecionados,
      * segundo argumento é os objetos selecionados
      */
      this.$emit('onSelectionChange', {
        ids: this.batch.ids,
        datas: this.batch.datas,
      });

      this.$emit('onSelectionChangeObj', {
        ids: this.batch.ids,
        datas: this.batch.datas,
      });
    },

    /**
    * Evento de pesquisa
    * @param data dados do formulario de pesquisa
    */
    onSearch(opts) {
      this.$emit('onSearch', opts);
    },

    /**
    * Evento de exclusao
    * @param  {object || boolean} user  Objeto atual selecionado ou um valor boleano
    * ,??/ quando um valor booleano que representa a maior apagar??
    * @param  {number} index indice da lista
    */
    onBatchDelete() {
      this.$emit('onClickBtnBatchDelete', {
        ids: this.batch.ids,
        datas: this.batch.datas,
      });
    },

    /**
    * Evento de adição
    * @param  {object || boolean} user  Objeto atual selecionado ou um valor boleano
    * ,??/ quando um valor booleano que representa a maior apagar??
    * @param  {number} index indice da lista
    */
    onBatchAdd() {
      this.$emit('onClickBtnBatchAdd', {
        ids: this.batch.ids,
        datas: this.batch.datas,
      });
    },

    /**
    * Evento de atualizacao
    * @param  {object || boolean} user  Objeto atual selecionado ou um valor boleano
    * ,??/ quando um valor booleano que representa a maior apagar??
    * @param  {number} index indice da lista
    */
    onBatchUpdate() {
      this.$emit('onClickBtnBatchUpdate', {
        ids: this.batch.ids,
        datas: this.batch.datas,
      });
    },

    /**
    * Evento de clique do botao
    * @param opts  parametros de entrada do evento
    * @param.attr  opts.type   string      qual o tipo do botão
          clicado(Add,Update,Delete,BatchDelete,Select,Audit,Dropdown
    * @param.attr  opts.index  number      Indice do item da lista selecionada
    * @param.attr  opts.data   object      Dados do item da lista selecionada
    * @param.attr  opts.list   array       Quando o usuario clica em outra coluna,
    * o campo armazena a lista de dados atual
    */
    onBtnEvent(opts) {
      switch (opts.type) {
        case 'Add':
          this.$emit('onClickBtnAdd', opts);
          break;
        case 'Update':
          this.$emit('onClickBtnUpdate', opts);
          break;
        case 'Delete':
          this.$emit('onClickBtnDelete', opts);
          break;
        case 'Dropdown':
          this.$emit('onClickBtnDropdown', opts);
          break;
        case 'BatchDelete':
          this.onBatchDelete();
          break;
        case 'Custom':
          this.$emit('onClickBtnCustom', opts);
          break;
        case 'Select':
          this.$emit('onClickBtnSelect', opts);
          break;
        case 'BatchAdd':
          this.onBatchAdd();
          break;
        case 'BatchUpdate':
          this.onBatchUpdate();
          break;
        case 'Audit':
          this.$emit('onClickBtnAudit', opts);
          break;
        case 'CustomDelete':
          this.$emit('onClickBtnCustomDelete', opts);
          break;
        case 'CustomSearch':
          this.$emit('onClickBtnCustomSearch', opts);
          break;
        case 'CustomButton':
          this.$emit('onClickBtnCustomButton', opts);
          break;
        case 'Column':
          this.$emit('onClickBtnColumn', opts);
          break;
        case 'DropdownColumn':
          this.$emit('onClickBtnDropdownColumn', opts);
          break;
        default:
          this.$emit('onClickBtn', opts);
      }
    },

    /**
    * eventos do botao personalizado
    * @param opts
    */
    onCustomBtnEvent(opts) {
      if (opts.btn.fn) {
        opts.btn.fn(opts);
      } else {
        this.$emit('onClickBtn', opts);
      }
    },

    /**
    * evento da mudanca da pagina atual
    * @param  {number} page pagina atual
    */
    onChangeCurrentPage(page) {
      this.$emit('onChangeCurrentPage', page);
    },

    /**
    * Evento da alteracao do numero da pagina
    * @param  {number} pagesize Novo Tamanho da pagina
    */
    onChangePageSize(pagesize) {
      this.$emit('onChangePageSize', pagesize);
    },

    strip(html) {
      const tmp = document.createElement('DIV');

      tmp.innerHTML = html;

      return tmp.textContent || tmp.innerText || '';
    },

    /**
    * Evento da alteracao da opcao radio
    * @param key identificador da coluna selecionada
    * @param row linha selecionada
    */
    onRadioChange(key, row) {
      this.$emit('onRadioChange', key, row);
    },

    /**
    * Evento da alteracao do input na coluna
    * @param key identificador da coluna alterada
    * @param row linha da coluna alterada
    */
    onInputColumnChange(key, row) {
      this.$emit('onInputColumnChange', key, row);
    },

    /**
    * Evento da alteracao do checkbox na coluna
    * @param value valor alterado do checkbox
    * @param index indice da linha da coluna alterada
    * @param key identificador da coluna alterada
    * @param row linha da coluna alterada
    */
    onCheckBoxChange(value, index, key, row) {
      this.$emit('onCheckBoxChange', value, index, key, row);
    },

    verificarObjeto(prop) {
      return prop.includes('.');
    },

    obterDadosLinha(row, prop) {
      const props = prop.split('.');
      let info = row;
      props.forEach((p) => {
        if (info !== undefined) {
          info = info[p];
        }
      });
      return info;
    },

    sort(field) {
      if (field.sortDirection === undefined || field.sortDirection === 'desc') {
        // eslint-disable-next-line no-param-reassign
        field.sortDirection = 'asc';
      } else {
        // eslint-disable-next-line no-param-reassign
        field.sortDirection = 'desc';
      }

      field.sort(field.key, field.sortDirection);
    },

    updateValue(value) {
      this.$emit('update:value', value);
    },
  },

  /**
  * Propriedades do componente
  */

  props: {
    List: {
      type: Array,
      required: true,
    },

    FieldList: {
      type: Array,
      required: true,
    },

    BtnInfo: {
      type: Object,
      default() {
        return {};
      },
    },

    Selection: {
      type: Boolean,
      default: false,
    },

    Expand: {
      type: Object,

      default() {
        return {
          show: false,
          position: 'left',
        };
      },
    },

    Pagination: {
      type: Object,
      default() {
        return {};
      },
    },

    Search: {
      type: Object,
      default() {
        return {};
      },
    },

    DropdownList: {
      type: Array,
      required: false,
    },

    TableRowClassName: {
      type: Function,
      default() {
        return null;
      },
    },

    SummaryMethod: {
      type: Function,
      default() {
        return null;
      },
    },

    StylePlain: {
      type: Boolean,
      required: false,
      default: false,
    },

    StyleCircle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};

</script>
<!--  -->
<style scoped lang='less'>
    .el-dropdown {
      margin-left: 10px;
    }

    .btm-action {
        margin-top: 20px;
        text-align: center;
    }

    .actions-top {
        height: 46px;
    }

    .pagination {
        display: -webkit-inline-box;
    }

    .el-tag {
      margin-right: 5px;
      margin-bottom: 10px;
    }

    .list {
      table {
        img {
          max-width: 100%;
          height: auto;
        }
      }
    }

    .list-header {
        display: inline-block;
    }

    .el-dropdown-menu {
      overflow: visible;
    }

</style>
